import React from 'react';
import './TicketStats.css';

function TicketStats({ data }) {
  return (
    <div className={"ticket-sold-box align-items-center " + (data.totalCount === 0 ? 'empty d-none' : 'd-flex')}> 
      {/*<div className="stat-card"></div>*/} 
        <span className='icon ticket-icon'>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tickets-icon lucide-tickets">
              <path d="m3.173 8.18 11-5a2 2 0 0 1 2.647.993L18.56 8"/>
              <path d="M6 10V8"/><path d="M6 14v1"/>
              <path d="M6 19v2"/>
              <rect x="2" y="8" width="20" height="13" rx="2"/>
            </svg> */}

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tickets-plane-icon lucide-tickets-plane"><path d="M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12"/><path d="m12 13.5 3.794.506"/><path d="m3.173 8.18 11-5a2 2 0 0 1 2.647.993L18.56 8"/><path d="M6 10V8"/><path d="M6 14v1"/><path d="M6 19v2"/><rect x="2" y="8" width="20" height="13" rx="2"/>
            </svg>
        </span> 
        <div className='w-auto'>
          <h5>Total Tickets Sold</h5>
          <h2 className="stat-value">{data.totalCount.toLocaleString()}</h2>
        </div> 
    </div>
  );
}

export default TicketStats;
